import { render } from "./app-container-comments.vue?vue&type=template&id=3042af09"
import script from "./app-container-comments.vue?vue&type=script&lang=js"
export * from "./app-container-comments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-container-comments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3042af09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3042af09', __exports__)) {
    console.log('reload')
    api.reload('3042af09', __exports__)
  }
  
  module.hot.accept("./app-container-comments.vue?vue&type=template&id=3042af09", () => {
    console.log('re-render')
    api.rerender('3042af09', render)
  })

}


export default __exports__